import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import {
  centerTypes,
  districts,
  zones,
} from "../../../../core/common/selectoption/selectoption";
import CenterModals from "../centerModals";
import CommonSelect from "../../../../core/common/commonSelect";
import { CenterResponseType } from "../types/centerResponse";
import { useCenterFilters } from "../hooks/useCenterFilters";

const CenterGrid = () => {
  const routes = all_routes;
  const {
    getCenterState,
    paginationData,
    recordsPerPage,
    setRecordsPerPage,
    tempFilters,
    sortConfig,
    handleFilterChange,
    handleSortChange,
    handleResetFilters,
    handleApplyFilters,
  } = useCenterFilters();
  const { centers, isLoading, error } = getCenterState();
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const [selectedCenterId, setSelectedCenterId] = useState<string>("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleApplyClick = () => {
    handleApplyFilters();
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const handleLoadMore = () => {
    setRecordsPerPage(recordsPerPage + 10);
  };

  const handleDeleteClick = (id: string) => {
    setSelectedCenterId(id);
    setShowDeleteModal(true);
  };

  if (error) {
    return (
      <div className="page-wrapper">
        <div className="content content-two text-center py-5">
          <div className="alert alert-danger mb-3">
            Error loading centers: {error}
          </div>
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Center List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Centers
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <TooltipOption /> */}

              <div className="mb-2">
                <Link
                  to={routes.addCenter}
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Center
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Filter */}
          <div className="bg-white p-3 border rounded-1 d-flex align-items-center justify-content-between flex-wrap mb-4 pb-0">
            <h4 className="mb-3">Center List</h4>
            <div className="d-flex align-items-center flex-wrap">
              <div className="dropdown mb-3 me-2">
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                >
                  <i className="ti ti-filter me-2" />
                  Filter
                </Link>
                <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                  <form>
                    <div className="d-flex align-items-center border-bottom p-3">
                      <h4>Filter</h4>
                    </div>
                    <div className="p-3 pb-0 border-bottom">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Zone</label>
                            <CommonSelect
                              className="select"
                              options={zones}
                              value={
                                zones.find(
                                  (option) =>
                                    option.value === tempFilters.zone
                                ) || null
                              }
                              onChange={(value) =>
                                handleFilterChange("zone", value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">District</label>
                            <CommonSelect
                              className="select"
                              options={districts}
                              value={
                                districts.find(
                                  (option) =>
                                    option.value === tempFilters.district
                                ) || null
                              }
                              onChange={(value) =>
                                handleFilterChange("district", value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Center Type</label>
                            <CommonSelect
                              className="select"
                              options={centerTypes}
                              value={
                                centerTypes.find(
                                  (option) =>
                                    option.value === tempFilters.center_type
                                ) || null
                              }
                              onChange={(value) =>
                                handleFilterChange("type", value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light me-3"
                        onClick={handleResetFilters}
                      >
                        Reset
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleApplyClick}
                      >
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                <Link
                  to={routes.centerList}
                  className="btn btn-icon btn-sm me-1 bg-light primary-hover"
                >
                  <i className="ti ti-list-tree" />
                </Link>
                <Link
                  to={routes.centerGrid}
                  className="active btn btn-icon btn-sm primary-hover"
                >
                  <i className="ti ti-grid-dots" />
                </Link>
              </div>
              <div className="dropdown mb-3">
                <Link
                  to="#"
                  className="btn btn-white border d-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-arrows-sort me-1 text-muted" />
                  {sortConfig.sort_by ? (
                    <span>
                      <span className="text-muted">Sort By:</span>{" "}
                      <span className="text-dark fw-medium">
                        {sortConfig.sort_by}
                      </span>
                      <i
                        className={`ms-1 ti ti-arrow-${sortConfig.sort_order === "asc" ? "up" : "down"
                          } text-muted`}
                      />
                    </span>
                  ) : (
                    <span className="text-muted">Sort By</span>
                  )}
                </Link>
                <div
                  className="dropdown-menu shadow border-0"
                  style={{ minWidth: "280px" }}
                >
                  <div className="p-3">
                    <h6 className="mb-0">
                      <i className="ti ti-arrows-sort me-2 text-muted"></i>
                      <span className="text-muted">Sort By Field</span>
                    </h6>
                  </div>

                  <div className="p-3">
                    <div className="mb-3">
                      <label className="form-label small">Sort Field</label>
                      <select
                        className="form-select"
                        value={sortConfig.sort_by || ""}
                        onChange={(e) => {
                          if (e.target.value) {
                            handleSortChange(
                              e.target.value,
                              sortConfig.sort_order || "asc"
                            );
                          } else {
                            handleSortChange("", "asc");
                          }
                        }}
                      >
                        <option value="">Select field</option>
                        <option value="name">Center Name</option>
                        <option value="code">Center Code</option>
                        <option value="zone">Zone</option>
                        <option value="district">District</option>
                        <option value="type">Center Type</option>
                      </select>
                    </div>

                    {sortConfig.sort_by && (
                      <div className="mb-3">
                        <label className="form-label small">
                          Sort Direction
                        </label>
                        <div className="btn-group w-100">
                          <button
                            type="button"
                            className={`btn ${sortConfig.sort_order === "asc"
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                            onClick={() =>
                              sortConfig.sort_by
                                ? handleSortChange(sortConfig.sort_by, "asc")
                                : null
                            }
                          >
                            <i className="ti ti-sort-ascending me-1"></i>
                            Ascending
                          </button>
                          <button
                            type="button"
                            className={`btn ${sortConfig.sort_order === "desc"
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                            onClick={() =>
                              sortConfig.sort_by
                                ? handleSortChange(sortConfig.sort_by, "desc")
                                : null
                            }
                          >
                            <i className="ti ti-sort-descending me-1"></i>
                            Descending
                          </button>
                        </div>
                      </div>
                    )}

                    {sortConfig.sort_by && (
                      <div>
                        <button
                          type="button"
                          className="btn btn-light btn-sm w-100 d-flex align-items-center justify-content-center"
                          onClick={() => handleSortChange("", "asc")}
                        >
                          <i className="ti ti-x me-1"></i>
                          Clear Sort
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Filter */}
          <div className="row">
            {isLoading ? (
              <div className="text-center">Loading centers...</div>
            ) : error ? (
              <div className="alert alert-danger m-3">
                Error loading centers: {error.toString()}
              </div>
            ) : (
              <>
                {centers?.length === 0 ? (
                  <div className="col-12 text-center py-5">
                    <h4>No centers found</h4>
                  </div>
                ) : (
                  centers?.map((center: CenterResponseType) => (
                    <div
                      className="col-xxl-3 col-xl-4 col-md-6 d-flex"
                      key={center.id}
                    >
                      <div className="card flex-fill">
                        <div className="card-header d-flex align-items-center justify-content-between">
                          <Link
                            to={routes.centerDetailsId.replace(
                              ":id",
                              String(center.id)
                            )}
                            className="link-primary"
                          >
                            {center.code}
                          </Link>
                          <div className="d-flex align-items-center">
                            <div className="dropdown">
                              <Link
                                to="#"
                                className="btn btn-white btn-sm"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="ti ti-dots-vertical" />
                              </Link>
                              <ul className="dropdown-menu dropdown-menu-end">
                                <li>
                                  <Link
                                    className="dropdown-item"
                                    to={routes.centerUsersId.replace(
                                      ":id",
                                      String(center.id)
                                    )}
                                  >
                                    <i className="ti ti-users me-2"></i>
                                    User List
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className="dropdown-item"
                                    to={routes.addUser.replace(
                                      ":id",
                                      String(center.id)
                                    )}
                                  >
                                    <i className="ti ti-user-plus me-2"></i>Add User
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className="dropdown-item rounded-1"
                                    to={routes.centerFeeDetails.replace(":id", String(center.id))}
                                  >
                                    <i className="ti ti-calculator me-2" />
                                    View Fee
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className="dropdown-item"
                                    to={routes.editCenter.replace(
                                      ":id",
                                      String(center.id)
                                    )}
                                  >
                                    <i className="ti ti-edit me-2"></i>Edit
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item"
                                    onClick={() => handleDeleteClick(center.id.toString())}
                                  >
                                    <i className="ti ti-trash me-2"></i>Delete
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="bg-light-300 rounded-2 p-3 mb-3">
                            <div className="d-flex align-items-center">
                              <div className="ms-2">
                                <h5 className="mb-0">
                                  <Link
                                    to={routes.centerDetailsId.replace(
                                      ":id",
                                      String(center.id)
                                    )}
                                  >
                                    {center.name}
                                  </Link>
                                </h5>
                                <p>{center.district}</p>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-between gx-2">
                            <div>
                              <p className="mb-0">Contact</p>
                              <p className="text-dark">{center.phone}</p>
                            </div>
                            <div>
                              <p className="mb-0">Email</p>
                              <p className="text-dark">{center.email}</p>
                            </div>
                          </div>
                        </div>
                        <div className="card-footer d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <Link
                              to={`tel:${center.phone}`}
                              className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle  p-0 me-2"
                            >
                              <i className="ti ti-phone" />
                            </Link>
                            <Link
                              to={`mailto:${center.email}`}
                              className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle p-0 me-3"
                            >
                              <i className="ti ti-mail" />
                            </Link>
                          </div>
                          <Link
                            to={routes.centerDetailsId.replace(
                              ":id",
                              String(center.id)
                            )}
                            className="btn btn-light btn-sm fw-semibold"
                          >
                            View Details
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </>
            )}

            {/* Load More Button - Only show when not loading and there's data */}
            {!isLoading &&
              paginationData?.pageSize &&
              paginationData?.totalItems &&
              paginationData.pageSize < paginationData.totalItems && (
                <div className="col-md-12 text-center">
                  <button className="btn btn-primary" onClick={handleLoadMore}>
                    <i className="ti ti-loader-3 me-2" />
                    Load More
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <CenterModals
        centerId={selectedCenterId}
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
      />
    </>
  );
};

export default CenterGrid;
